import createLucideIcon from '../createLucideIcon';

const Copyleft = createLucideIcon('Copyleft', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M9 9.35a4 4 0 1 1 0 5.3', key: 'p8fkhi' }],
]);

export default Copyleft;
